import React, { useState } from 'react';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';

import { Box, Button, Radio, RadioGroup, Stack } from '@tq/ui-components';
import { useIsMobile } from '@tq/ui-components/dist/hooks';

import { ActiveLayer } from '.';

type LayerToggleProps = {
  handleOnChange: (value: ActiveLayer) => void;
  activeLayer: ActiveLayer;
};

export const LayerToggle: React.FunctionComponent<LayerToggleProps> = ({
  handleOnChange,
  activeLayer,
}) => {
  const [displayOptions, setDisplayViewOptions] = useState(false);

  const isMobile = useIsMobile();

  const toggleElements = (
    <RadioGroup
      onChange={(value) => handleOnChange(value as unknown as ActiveLayer)}
      value={activeLayer}
    >
      <Stack direction={['column', 'row']} spacing={'1rem'}>
        <Radio value={ActiveLayer.SATELLITE}>Satellite view</Radio>
        <Radio value={ActiveLayer.MAP}>Map view</Radio>
      </Stack>
    </RadioGroup>
  );

  const icon = displayOptions ? <FaChevronUp /> : <FaChevronDown />;

  return (
    <>
      {isMobile ? (
        <Box
          bg='white'
          className='layer-toggle'
          sx={{
            borderRadius: '4px',
            padding: displayOptions ? '.8rem 1rem 1rem ' : '.8rem 1rem 0',
          }}
        >
          <Button
            variant='tertiary'
            rightIcon={icon}
            onClick={() => setDisplayViewOptions((s) => !s)}
            sx={{
              minWidth: 'unset !important',
              padding: '0',
              justifyContent: 'start',
              border: 'unset',
              color: '#1076BC !important',
              mb: displayOptions ? '0.8rem' : 'unset',
              '&:focus': {
                boxShadow: 'unset',
              },
              '&:hover': {
                background: 'unset',
              },
              '&:active': {
                background: 'unset',
              },
            }}
          >
            View options
          </Button>
          {displayOptions && toggleElements}
        </Box>
      ) : (
        <Box
          bg='white'
          className='layer-toggle'
          sx={{
            padding: '.5rem 1rem',
            borderRadius: '4px',
            position: 'absolute',
            right: '0px',
            top: '50%',
            transform: 'translateY(-50%)',
          }}
        >
          {toggleElements}
        </Box>
      )}
    </>
  );
};
